import { Box } from "@mui/material";
import { BlurredBackground } from "components/primitives/BlurredBackground";
import { DrawerSubHeaderText } from "components/primitives/DrawerSubHeaderText";
import { DrawerToggleIndicator } from "components/primitives/DrawerToggleIndicator";
import { HeaderText } from "components/primitives/HeaderText";
import { SwipeableArea } from "components/primitives/SwipeableArea";
import { useAppSelector } from "hooks/utilsHooks/storeHooks";
import { useTranslation } from "react-i18next";
import { selectRefillSummary } from "slices/refillSummarySelectors";
import { DrawerWrapper } from "./components/orderStepDrawerStyles";
import { RefillSummarySection } from "./components/RefillSummarySection";
import type { BaseOrderStepProps } from "./OrderStep2";

const BODY_TOP_OFFSET = "220px";
// Keeps the last row clear of the fixed action bar, whose button confirms and counts down (DrawerActionBar).
const ACTION_BAR_CLEARANCE = "120px";

// Step 5 of a FINISHED local refill (JID-2360): what the fridge registered as added and removed.
export const RefillSummaryStep = ({ open, toggleDrawer }: BaseOrderStepProps) => {
	const summary = useAppSelector(selectRefillSummary);
	const { t } = useTranslation();

	return (
		<>
			<SwipeableArea orderstep={5} open={open}>
				{!open && <BlurredBackground orderStep={5} open={open} />}
				<DrawerToggleIndicator open={open} toggleDrawer={toggleDrawer} />
				<Box sx={{ display: "flex", flexDirection: "column", paddingTop: 2, marginBottom: 2 }}>
					<HeaderText variant="h3" hasBorder={true}>
						{t("order.refillSummary.title")}
					</HeaderText>
					<DrawerSubHeaderText>{t("order.refillSummary.subtitle")}</DrawerSubHeaderText>
				</Box>
			</SwipeableArea>
			<DrawerWrapper
				data-testid="refill-summary-step"
				sx={{
					...(open && { marginTop: BODY_TOP_OFFSET, height: `calc(100% - ${BODY_TOP_OFFSET})` }),
					paddingBottom: ACTION_BAR_CLEARANCE,
					gap: 3,
				}}
			>
				<RefillSummarySection variant="added" section={summary.added} />
				<RefillSummarySection variant="removed" section={summary.removed} />
			</DrawerWrapper>
		</>
	);
};
